import React, { useState } from 'react';
import { Calendar, Music, PartyPopper } from 'lucide-react';
import { beachEvents } from '../data/mockData';

const BeachEventsSection = () => {
  const [selectedMonth, setSelectedMonth] = useState('Alle');
  const months = ['Alle', 'Mai', 'Juni', 'Juli', 'August'];

  const filteredEvents = selectedMonth === 'Alle' 
    ? beachEvents 
    : beachEvents.filter(event => event.month === selectedMonth);

  return (
    <section id="beach-events" className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #1A0520, #0A0015)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <PartyPopper className="w-12 h-12 mx-auto mb-4" style={{ color: '#FFD700', filter: 'drop-shadow(0 0 10px #FFD700)' }} />
          <h2 className="text-4xl md:text-5xl font-bold mb-4 px-6 py-2 inline-block" style={{
            fontFamily: "'Great Vibes', cursive",
            color: '#FFFFFF',
            textShadow: '0 0 10px #FFFFFF, 0 0 20px #FFFFFF, 0 0 30px #FFFFFF',
            WebkitTextStroke: '1px black',
            paintOrder: 'stroke fill',
            background: '#FFFF00',
            boxShadow: '0 0 20px #FFFF00, 0 0 40px #FFFF00',
            borderRadius: '0.5rem'
          }}>
            Beach Events 2026
          </h2>
          <div className="h-1 w-24 mx-auto rounded-full mt-4" style={{ background: 'linear-gradient(to right, #FFD700, #FFA500)' }} />
          <p className="text-white/80 text-lg mt-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Regelmäßige Saale Beach Events und besondere Veranstaltungen
          </p>
          <p className="text-white/60 text-sm mt-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Am Bleichrasen, 97762 Hammelburg
          </p>
        </div>

        {/* Monatsfilter */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {months.map((month) => (
            <button
              key={month}
              onClick={() => setSelectedMonth(month)}
              className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 ${
                selectedMonth === month
                  ? 'text-bg-dark'
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}
              style={{
                fontFamily: "'Montserrat', sans-serif",
                background: selectedMonth === month ? '#FFD700' : undefined,
                boxShadow: selectedMonth === month ? '0 0 20px #FFD700' : undefined
              }}
            >
              {month}
            </button>
          ))}
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredEvents.map((event) => (
            <div key={event.id} className="glass-card p-6 relative overflow-hidden group hover:border-[#FFD700] transition-all duration-300">
              <div className="absolute top-4 right-4 bg-[#FFD700] text-bg-dark px-3 py-1 rounded-full text-xs font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {event.month}
              </div>
              
              <div className="flex items-start gap-3 mb-4">
                <Calendar className="w-6 h-6 mt-1 flex-shrink-0" style={{ color: '#FFD700' }} />
                <div>
                  <p className="text-white font-bold text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {event.date}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 mb-4">
                <Music className="w-6 h-6 mt-1 flex-shrink-0" style={{ color: '#FFD700' }} />
                <div>
                  <h3 className="text-2xl font-bold mb-2" style={{ 
                    fontFamily: "'Playfair Display', serif",
                    color: '#FFD700'
                  }}>
                    {event.artist}
                  </h3>
                  <p className="text-white/70 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {event.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredEvents.length === 0 && (
          <div className="text-center text-white/60 py-12" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Keine Events für diesen Monat
          </div>
        )}

        <div className="text-center mt-12">
          <a
            href="#contact"
            className="inline-block px-8 py-3 rounded-full font-semibold transition-all duration-300"
            style={{
              background: 'transparent',
              border: '2px solid #FFD700',
              color: '#FFD700',
              fontFamily: "'Montserrat', sans-serif",
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              fontSize: '0.875rem',
              boxShadow: '0 0 10px rgba(255, 215, 0, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#FFD700';
              e.target.style.color = '#0A0015';
              e.target.style.boxShadow = '0 0 20px #FFD700';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#FFD700';
              e.target.style.boxShadow = '0 0 10px rgba(255, 215, 0, 0.3)';
            }}
          >
            Kontakt Aufnehmen
          </a>
        </div>
      </div>
    </section>
  );
};

export default BeachEventsSection;
